import { css, cx } from '@portal/styled-system/css'

import { toast } from '@/shared/lib/toast'

export type VersionBadgeProps = {
    label: string
    value: string
    className?: string
}

export function VersionBadge({ label, value, className }: VersionBadgeProps) {
    function handleClick() {
        navigator.clipboard.writeText(value)
        toast.successFx({ message: `Copied: ${value}` })
    }

    return (
        <li className={cx(versionBadge, className)} onClick={handleClick}>
            {label}: {value}
        </li>
    )
}

const versionBadge = css({
    color: 'neutral.600',
    border: '[1px dashed {colors.neutral.400}]',
    borderRadius: 'sm',
    fontSize: '[12px]',
    paddingX: '2',
    paddingY: '[3px]',
    marginRight: '1',
    cursor: 'pointer',
    _hover: {
        color: 'neutral.700',
        borderColor: 'neutral.500',
    },
})
